module.exports = __webpack_public_path__ + "static/media/ic-success-round-green.6b4cd51e.svg";